export default __webpack_public_path__ + "static/flopPmToFlopApp-77d4daa88c672b96c2b860505af1e9b1.png";